import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
	esp: (
		`
		<div style="text-align: justify;">
			<p class="mb-3">
				Komence estis nenio. Primara tenebro, sen pezo, sen dimensioj. Mi estis nur sago, nur strebo al plenumiĝo. Kaj poiomete mi komencis posedi korpon, peziĝi, figuriĝi… Venis tempo, kiam mi eksentis limojn de mia ejo. Ne plu estis medio ĉirkaŭ mi, mi mem fariĝis tiu medio, kaj jam estis neelteneble resti en tiu streĉita ejo, mi strebis elen.
			</p>
			
			<p class="mb-3">
				En potenca elano mi frakasis la vandon kaj eliris al lume brilanta mondo. Super mi estis brila ĉielo, kaj post kelkaj semajnoj mi jam flugis en tiu senlima bluo. Mi estas libera posedanto de la tuta aero!
			</p>
			
			<p class="mb-3">
				Sed iam mi estis nur ovo…
			</p>
			
		</div>

		`
	)
}

const itemName = {
	esp: 'La vojo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp
	}
}

export default item;